import { render } from "./TechStackCard.vue?vue&type=template&id=efc92410&scoped=true"
import script from "./TechStackCard.vue?vue&type=script&lang=js"
export * from "./TechStackCard.vue?vue&type=script&lang=js"

import "./TechStackCard.vue?vue&type=style&index=0&id=efc92410&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efc92410"]])

export default __exports__